/**
 * Who operates RealityTwin.io. One source of truth, because the imprint, the
 * contracts and the structured data must never disagree about the legal entity
 * behind the platform.
 */
export const OPERATOR = {
  project: "RealityTwin.io",
  legalName: "Ruznic Marketing",
  owner: "Ajdin Ruznic",
  legalForm: "Einzelunternehmen",
  street: "Leimgrubstrasse 5",
  postalCode: "8340",
  city: "Hinwil",
  country: "Schweiz / Switzerland",
  email: "hello@realitytwin.io",
  web: "realitytwin.io",
  operatorWeb: "https://ruznic-marketing.com",
} as const;

/** One-line postal address, as it appears in contracts. */
export const OPERATOR_ADDRESS = `${OPERATOR.legalName}, ${OPERATOR.street}, ${OPERATOR.postalCode} ${OPERATOR.city}, Schweiz`;

/** The platform's share of a brokered engagement, in percent. */
export const PLATFORM_FEE_PERCENT = 10;
